import MUserPreview from './UserPreviewPure.vue';

export { MUserPreview };
export default MUserPreview;
